module.exports = __webpack_public_path__ + "static/img/200242.b534cbe2.png";